function loadImages(imagesToLoad) {
  const images = {};

  Object.keys(imagesToLoad).forEach((name) => {
    loadImage(imagesToLoad[name], name, images);
  });

  return images;
}

export function loadImage(url, name, images) {
  const img = new Image();

  // for use from jordanjwatkins.bitbucket.io
  img.src = 'assets/' + url;

  // for local dev
  //img.src = url;

  img.onload = () => {
    images[name] = img;
  };
}

export function flipImage(image, w, h) {
  const tmpCanvas = document.createElement('canvas');
  const tmpContext = tmpCanvas.getContext('2d');

  tmpCanvas.width = w;
  tmpCanvas.height = h;

  tmpContext.translate(tmpCanvas.width, 0);
  tmpContext.scale(-1, 1);

  tmpContext.drawImage(image, 0, 0);

  return tmpCanvas.toDataURL();
}

export default loadImages;
